import LocaleService from '../services/locale.service';

export class DistanceHelper {
  public static format(value: number | undefined | null): string {
    if (value === null || value === undefined || value < 0) {
      return '';
    }

    const locale = window.navigator.language || LocaleService.getLocale();
    if (value < 1000) {
      return `${value.toLocaleString(locale)} m`;
    }
    return `${(value / 1000).toLocaleString(locale, { minimumFractionDigits: 0, maximumFractionDigits: 1 })} km`;
  }
}
